module.exports = __webpack_public_path__ + "img/diamondIcon.854866b3.svg";